import { Flex } from '@lokalise/louis';
import { css, modifier, styled } from '@lokalise/styled';

import { color, mediaQuery, radius, spacing, transition, value } from '@app/theme';

export const IconContainer = styled(Flex)`
    width: 24px;
    height: 24px;
    flex-shrink: 0;
`;

export const TextContainer = styled.p`
    ${mediaQuery.max('md')} {
        display: none;
    }
    white-space: nowrap;

    color: ${color('text.default')};
`;

export const InProgressText = styled.p`
    ${mediaQuery.max('md')} {
        display: none;
    }
    white-space: nowrap;

    color: ${color('text.light.default')};

    span {
        @keyframes blink {
            50% {
                color: transparent;
            }
        }
        animation: 1s blink infinite;

        &:nth-child(2) {
            animation-delay: 250ms;
        }

        &:nth-child(3) {
            animation-delay: 500ms;
        }
    }
`;

export const LogoContainer = styled.div`
    width: 24px;
    height: 24px;
    border-radius: ${radius('m')};
    border: 1px solid ${value('color.border.light')};
    background-color: ${value('color.background.surface.default')};
    flex-shrink: 0;
`;

export const SyncButtonContainer = styled.button<{
    $hasError?: boolean;
    $hasWarning?: boolean;
    $inProgress?: boolean;
    $disableCursor?: boolean;
}>`
    padding: ${spacing(2)};
    display: grid;
    align-items: center;
    grid-template-columns: auto auto;
    background-color: ${value('color.background.surface.middle')};
    transition: background-color ${transition('default')};
    border-radius: ${radius('l')};

    &:hover {
        background-color: ${({ $inProgress }) => ($inProgress ? 'unset' : color('background.ai'))};
        background-color: ${({ $hasError, $hasWarning }) => {
            if ($hasError) {
                return color('background.danger');
            }

            if ($hasWarning) {
                return color('background.warning');
            }

            return null;
        }};
    }

    &:focus {
        background-color: ${({ $inProgress }) => ($inProgress ? 'unset' : color('border.ai'))};
        background-color: ${({ $hasError, $hasWarning }) => {
            if ($hasError) {
                return color('background.danger');
            }

            if ($hasWarning) {
                return color('background.warning');
            }

            return null;
        }};
    }

    ${modifier(
        '$disableCursor',
        css`
            cursor: not-allowed;
            pointer-events: unset;
        `,
    )};

    // Reset button styles
    border: none;
    margin: 0;
    width: auto;
    overflow: visible;
    color: inherit;
    font: inherit;
    line-height: normal;
    -webkit-font-smoothing: inherit;
    -moz-osx-font-smoothing: inherit;
    -webkit-appearance: none;
`;
